import { render, staticRenderFns } from "./ApprovalConfirm.vue?vue&type=template&id=ba9b43b8&scoped=true&"
import script from "./ApprovalConfirm.vue?vue&type=script&lang=js&"
export * from "./ApprovalConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9b43b8",
  null
  
)

export default component.exports